<template>
  <transition name="fade">
    <div v-if="visible" :class="[baseCss, rounded ? 'rounded' : null, setBgColor(), setTextColor(), `bcq-snackbar-x-position-${xPosition}`, `bcq-snackbar-y-position-${yPosition}`]" role="alert" :style="{width, zIndex}">
      <table-layout y-align="middle">
        <row>
          <cell :class="['text-xs', 'p-2']" full-width>
            <slot />
          </cell>
          <cell :class="['p-2']">
            <btn @click="dismiss" :size="buttonSize" plain :color="dismissButtonColor" :color-lightness="dismissButtonColorLightness" :title="dismissButtonText">{{ dismissButtonText }}</btn>
          </cell>
        </row>
      </table-layout>
    </div>
  </transition>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'
import Utils from '../../mixins/utils'

export default {
  name: 'Snackbar',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      timer: null,
      baseCss: this.componentBaseCss('snackbar', ['select-none', 'fixed', 'shadow-md', 'outline-none'])
    }
  },
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: {
    visible: {
      type: Boolean
    },
    buttonSize: {
      default: 'xs'
    },
    rounded: {
      type: Boolean
    },
    width: {
      type: String,
      default: '288px'
    },
    xPosition: {
      type: String,
      default: 'center',
      validator: value => {
        return ['left', 'center', 'right'].includes(value)
      }
    },
    yPosition: {
      type: String,
      default: 'bottom',
      validator: value => {
        return ['top', 'bottom'].includes(value)
      }
    },
    dismissButtonText: {
      type: String,
      default: 'Close'
    },
    dismissButtonColor: {
      type: String,
      default: 'white'
    },
    dismissButtonColorLightness: {
      type: [Number, String],
      default: null,
      validator: value => {
        const utils = new Utils()
        return utils.validateLightness(value)
      }
    },
    bgColor: {
      type: String,
      default: 'gray'
    },
    color: {
      type: String,
      default: 'white'
    },
    zIndex: {
      type: Number,
      default: 1600
    },
    autoCloseDelay: {
      type: Number,
      default: 5000
    }
  },
  watch: {
    visible () {
      clearTimeout(this.timer)
      if (this.visible) {
        this.timer = setTimeout(() => {
          this.dismiss()
        }, this.autoCloseDelay)
      }
    }
  },
  methods: {
    dismiss () {
      this.$emit('input', false)
    }
  }
}
</script>
<style>
.bcq-snackbar.bcq-snackbar-x-position-center
{
  left: 50%;
  transform: translatex(-50%);
}

.bcq-snackbar.bcq-snackbar-x-position-left
{
  left: 2rem;
}

.bcq-snackbar.bcq-snackbar-x-position-right
{
  right: 2rem;
}

.bcq-snackbar.bcq-snackbar-y-position-bottom
{
  bottom: 0;
}

.bcq-snackbar.bcq-snackbar-y-position-top
{
  top: 0;
}

.bcq-snackbar.bcq-snackbar-x-position-left.bcq-snackbar-y-position-bottom,
.bcq-snackbar.bcq-snackbar-x-position-right.bcq-snackbar-y-position-bottom
{
  bottom: 2rem;
}

.bcq-snackbar.bcq-snackbar-x-position-left.bcq-snackbar-y-position-top,
.bcq-snackbar.bcq-snackbar-x-position-right.bcq-snackbar-y-position-top
{
  top: 2rem;
}

@media (max-width: 480px) {
  .bcq-snackbar
  {
    left: 0 !important;
    right: 0 !important;
    transform: none !important;
    width: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/snackbar/snackbar.vue